import Firmware from './Firmware'

export default Firmware
